import React from "react";

import styles from "../ReviewAndSubmit.module.css";

interface IWebsitesListsProps {
  websites: string[];
  question: string;
}

export const WebsitesListInfo = ({
  websites,
  question,
}: IWebsitesListsProps) => {
  if (!websites || !websites.length) {
    return <></>;
  }

  return (
    <div
      className={`${styles.websitesListInfo} ${styles.containerInfo}`}
      data-testid="website-saved-info"
    >
      <div className={styles.question}>{question}</div>
      <ul>
        {websites.map((url) => {
          return (
            <li key={url}>
              <a
                className="milo--link"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                {url}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
